import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Button,
  Checkbox,
  ListItem,
  makeStyles
} from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const colorList = ['#00e676', '#00b0ff', '#651fff', '#ff9800', '#ff1744', '#3d5afe'];

const useStyles = makeStyles((theme) => ({
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium,
    justifyContent: 'flex-start',
    letterSpacing: 0,
    padding: '10px 8px',
    textTransform: 'none',
    width: '100%'
  },
  icon: {
    marginRight: theme.spacing(1)
  },
  title: {
    marginRight: 'auto'
  },
  active: {
    color: theme.palette.primary.main,
    '& $title': {
      fontWeight: theme.typography.fontWeightMedium
    },
    '& $icon': {
      color: theme.palette.primary.main
    }
  }
}));

const NavItem = ({
  className,
  onChecked,
  termId,
  href,
  icon,
  title,
  slug,
  colorKey,
  status,
  ...rest
}) => {
  const classes = useStyles();
  const labelId = `checkbox-list-secondary-label-${title}`;
  // const colorCode = colorList[(colorKey) % colorList.length];
  const [checked, setChecked] = React.useState(true);
  let colorCode;
  // eslint-disable-next-line default-case
  if (slug === 'slang') {
    colorCode = '#FF6548';
  } else if (slug === 'idiom') {
    colorCode = '#FF8A00';
  } else if (slug === 'expression') {
    colorCode = '#F7DF19';
  } else if (slug === 'noun') {
    colorCode = '#1BAC33';
  } else if (slug === 'verb') {
    colorCode = '#58B4DD';
  } else if (slug === 'pattern') {
    colorCode = '#3337B3';
  } else if (slug === 'culture') {
    colorCode = '#AF56B4';
  } else {
    colorCode = '#5F5F5F';
  }
  const handleToggle = (e) => {
    onChecked(e);
  };

  return (
    <ListItem
      className={clsx(classes.item, className)}
      disableGutters
      {...rest}
    >
      <Button
        className={classes.button}
      >
        <FiberManualRecordIcon
          className={classes.icon}
          size="20"
          style={{ color: colorCode }}
        />
        <span className={classes.title}>
          {title}
        </span>
        <Checkbox
          edge="end"
          onChange={handleToggle}
          checked={status}
          value={termId}
          inputProps={{
            'aria-labelledby': labelId,
            'data-index': `${colorKey}`
          }}
        />
      </Button>
    </ListItem>
  );
};

NavItem.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  title: PropTypes.string
};

export default NavItem;
